<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Camiones
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Camiones</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="agregar(); showModalAgregar()" size="sm"
        mdbWavesEffect>Agregar</button>
    </div>
    <div class="row filtros-body">
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="tipobusqueda" [value]="1" mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="tipobusqueda" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="tipobusqueda" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="filtraxEstado()" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>




<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">

    <div class="table-responsive">
      <cdk-virtual-scroll-viewport itemSize="27" class="viewport">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Patente</th>
              <th scope="col">Descripcion</th>
              <th scope="col">Chofer</th>
              <th scope="col">Peso Máximo</th>
              <th scope="col">Volumen Máximo</th>
              <th scope="col">Activo</th>
              <th scope="col"></th>
            </tr>
          </thead>

          <tbody>
            <tr *cdkVirtualFor="let cam of camionList">
              <td>{{ cam.patente }}</td>
              <td>{{ cam.descripcion }}</td>
              <td>{{ cam.nombre_chofer }}</td>
              <td>{{ cam.peso_maximo }}</td>
              <td>{{ cam.volumen }}</td>
              <td>
                <!-- <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="cam.caactivo"
                  />
                  <label class="form-check-label" for="checkbox1"></label>
                </div> -->
                <div *ngIf="cam.activo">
                  <mdb-badge pill="true" success="true">Activo</mdb-badge>
                </div>
                <div *ngIf="!cam.activo">
                  <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
                </div>
              </td>
              <td>
                <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                  data-toggle="modal" data-target="#basicExample" (click)="showModalModificar(); showForEdit(cam)"
                  mdbTooltip="Editar" placement="right">
                  <mdb-icon fas icon="pen"></mdb-icon>
                </button>
                <button *ngIf="!cam.activo" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                  (click)="permitirCambioEstado(cam)" mdbTooltip="Activar" placement="right">
                  <mdb-icon fas icon="ban"></mdb-icon>
                </button>
                <button *ngIf="cam.activo" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                  (click)="permitirCambioEstado(cam)" mdbTooltip="Desactivar" placement="right">
                  <mdb-icon fas icon="check"></mdb-icon>
                </button>
              </td>
            </tr>

          </tbody>

        </table>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>


<!--Modal de creacion de camiones-->
<div mdbModal #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formAgregarCamion_Sucursal">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Agregar
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLarge.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del camión
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="activo" formControlName="activo" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input placeholder="XXXX-99 o XX-9999" class="form-control" type="text" id="patente"
                    formControlName="patente" value="" maxlength="7" />
                  <label for="patente">Patente <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                          frmAgregaPatente.invalid &&
                          (frmAgregaPatente.dirty || frmAgregaPatente.touched)
                        ">
                    <mdb-error *ngIf="frmAgregaPatente.errors.ValidaFormatoPatente">
                      La patente tiene un formato incorrecto
                    </mdb-error>
                  </div>
                </div>

                <div class="md-form">
                  <input value="" type="text" id="descripcion" class="form-control" formControlName="descripcion"
                    placeholder="Descripción" />
                  <label for="descripcion">Descripción</label>
                  <div *ngIf="
                          frmAgregaDescripcion.invalid &&
                          (frmAgregaDescripcion.dirty ||
                            frmAgregaDescripcion.touched)
                        ">
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.maxlength">
                      El nombre no puede superar los 100 caracteres
                    </mdb-error>
                  </div>
                </div>

                <div class="md-form" *ngIf="parametroNegocio">
                  <mdb-select label="Unidad Negocio" [options]="optionsUnidadNegocio" [multiple]="true"
                    [filterEnabled]="true" [highlightFirst]="false" formControlName="unidad_negocio_codigo"
                    placeholder="Unidad Negocio"></mdb-select>
                </div>

              </div>
              <div class="col">
                <div class="md-form">
                  <input value="" type="number" step="0.1" id="volumen" class="form-control" formControlName="volumen"
                    placeholder="(m3) Espacio ocupable" />
                  <label for="volumen">Cubicación <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                          frmAgregaVolumen.invalid && frmAgregaVolumen.touched
                        ">
                    <mdb-error *ngIf="frmAgregaVolumen.errors.required">
                      La cubicación es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaVolumen.errors.min">
                      La cubicación no puede ser cero
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="(Kgs.) Capacidad de carga" class="form-control" type="number" step="0.1"
                    id="peso_maximo" formControlName="peso_maximo" value="" />
                  <label for="peso_maximo">Tonelaje <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                          frmAgregaPeso_Maximo.invalid &&
                          (frmAgregaPeso_Maximo.dirty ||
                            frmAgregaPeso_Maximo.touched)
                        ">
                    <mdb-error *ngIf="frmAgregaPeso_Maximo.errors.required">
                      El tonelaje es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaPeso_Maximo.errors.min">
                      El tonelaje no puede ser cero
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 50%;">
                <div class="md-form">
                  <mdb-select [multiple]="false" [filterEnabled]="true" [highlightFirst]="false" 
                    placeholder="Seleccionar chofer" [options]="optionsChofer" formControlName="chofer"></mdb-select>
                  <label>Chofer</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLarge.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
            [disabled]="!formAgregarCamion_Sucursal.valid" (click)="ValidaQueExisteDatosCamion();">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!--Modificar camiones-->
<div mdbModal #centralLargex="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formEditarCamion_Sucursal">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Modificar Camiones
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLargex.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del camión
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="caactivox"
                      formControlName="activo" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input placeholder="XXXX-99 o XX-9999" formControlName="patente" class="form-control" type="text"
                    id="patentex" />
                  <label for="patentex">Patente <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                          frmEditaPatente.invalid &&
                          (frmEditaPatente.dirty || frmEditaPatente.touched)
                        ">
                    <mdb-error *ngIf="frmEditaPatente.errors.ValidaFormatoPatente">
                      La patente tiene un formato incorrecto
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input type="text" id="descripcionx" formControlName="descripcion" class="form-control" />
                  <label for="descripcionx">Descripcion</label>
                  <div *ngIf="
                          frmEditaDescripcion.invalid &&
                          (frmEditaDescripcion.dirty ||
                            frmEditaDescripcion.touched)
                        ">
                    <mdb-error *ngIf="frmEditaDescripcion.errors.maxlength">
                      El nombre no puede superar los 100 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form" *ngIf="parametroNegocio">
                  <mdb-select label="Unidad Negocio" [options]="optionsUnidadNegocio" [multiple]="true"
                    [filterEnabled]="true" [highlightFirst]="false" formControlName="unidad_negocio_codigo"
                    placeholder="Unidad Negocio"></mdb-select>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input value="" type="number" step="0.1" id="volumenx" formControlName="volumen" class="form-control"
                    placeholder="(m3) Espacio ocupable" />
                  <label for="volumenx">Cubicaje <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                          frmEditaVolumen.invalid &&
                          (frmEditaVolumen.dirty || frmEditaVolumen.touched)
                        ">
                    <mdb-error *ngIf="frmEditaVolumen.errors.required">
                      La cubicación es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmEditaVolumen.errors.min">
                      La cubicación no puede ser cero
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Peso Máximo" formControlName="peso_maximo" class="form-control" type="number"
                    step="0.1" id="peso_maximox" />
                  <label for="peso_maximox">Tonelaje <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                          frmEditaPeso_Maximo.invalid &&
                          (frmEditaPeso_Maximo.dirty ||
                            frmEditaPeso_Maximo.touched)
                        ">
                    <mdb-error *ngIf="frmEditaPeso_Maximo.errors.required">
                      El tonelaje es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmEditaPeso_Maximo.errors.min">
                      El tonelaje no puede ser cero
                    </mdb-error>
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 50%;">
                <div class="md-form">
                  <mdb-select [multiple]="false" [filterEnabled]="true" [highlightFirst]="false" 
                    placeholder="Seleccionar chofer" [options]="optionsChofer" formControlName="chofer"></mdb-select>
                  <label>Chofer</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLargex.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
            [disabled]="!formEditarCamion_Sucursal.valid" (click)="actualizar();">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>